import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/icon_review.svg'
import _imports_1 from '../assets/icons/icon_menu.svg'


const _hoisted_1 = {
  id: "feedback",
  class: "max-w-1440px mx-auto pt-110px <lg:pt-70px <sm:pt-30px"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "w-910px <1200:w-full <1200:px-150px <lg:px-80px <sm:px-20px <sm:w-full mx-auto mt-168px <lg:mt-110px relative z-2" }
const _hoisted_4 = { class: "absolute abs-horiz-center -top-160px <sm:-top-80px -z-1" }
const _hoisted_5 = { class: "absolute abs-vert-center right-185px <xl:right-85px <lg:right-40px z-5" }
const _hoisted_6 = {
  class: "fill-black h-40px w-40px <xl:h-30px <xl:w-30px",
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_block = _resolveComponent("top-block")!
  const _component_the_feedback_section_carousel = _resolveComponent("the-feedback-section-carousel")!
  const _component_parallax_div = _resolveComponent("parallax-div")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_block, {
      class: "",
      title: "Отзывы"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Клиенты нас любят")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_feedback_section_carousel),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_parallax_div, { class: "" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                "data-depth": "0.2",
                src: _imports_0
              }, null, -1)
            ])),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_router_link, {
        to: "/menu",
        class: "hover:opacity-60 <sm:hidden"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_5, [
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_directive_svg_inline]
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}